export const INDEXER_ORDER_RESPONSE_TIME_MS = 4000;
export const INDEXER_ORDERS_OFFSET = 16;
